import React from "react";
import "../StoragePages.scss";
import { Page } from "components/core/Page";
import { StorageHeader } from "components/storages/Header";
import {
	BorderLine,
	Description,
	Heading,
	LastSearchBar,
	ListPoint,
	PopularCities
} from "components/storages/Common";
import { SELF_STORAGE_DATA } from "components/storages/ContentData/SelfStorageData";
import { SELF_CITIES_LINKS } from "components/storages/CitiesLinks/SelfCitiesLinks";
import Container from "components/core/Page/Container";
import { ScrollToTop } from "components/core/ScrollToTop";
import { useSelector } from "react-redux";
import { PAGE_SUB_TYPES } from "@sparefoot/tracking-events";
import usePageViewTracking from "hooks/tracking/usePageViewTracking";

function SelfStoragePage() {
	const baseUrl = useSelector((state) => state?.app?.baseUrl);
	usePageViewTracking(PAGE_SUB_TYPES.STORAGE_LANDING);
	return (
		<Page
			className="storage-page"
			pageType={PAGE_SUB_TYPES.STORAGE_LANDING}
			title="Affordable Self Storage Near You | Storage.com"
			description="Budget-friendly storage made easy: Compare rates and sizes 
			to find affordable self storage that meets your needs. Get started 
			with Storage.com!"
			canonical={`${baseUrl}/self-storage/`}
		>
			<Container>
				<StorageHeader
					heading="Find Self Storage Near You!"
					searchIn="self"
					level="1"
				/>
				<div className="all-sections">
					{SELF_STORAGE_DATA?.map((item, index) => (
						<>
							<Heading
								content={item.heading}
								level="2"
							/>
							<Description desc={item.description} />
							{item.description2 ? (
								<Description desc={item.description2} />
							) : null}
							<ul>
								{item.points &&
									item.points.map((point) => (
										<ListPoint desc={point.desc} />
									))}
							</ul>
							{item.descriptionWithLink ? (
								<Description
									descLink={item.descriptionWithLink}
								/>
							) : null}
							{item.popularCities ? (
								<PopularCities cityLinks={SELF_CITIES_LINKS} />
							) : null}

							{index !== SELF_STORAGE_DATA.length - 1 && (
								<BorderLine />
							)}
						</>
					))}

					<LastSearchBar level="2" />
				</div>
			</Container>
			<ScrollToTop />
		</Page>
	);
}

export default SelfStoragePage;
